import { useEffect, useState, createContext, useContext, Context } from 'react';
import {
	condolivre,
	wohpag,
	partnerbank,
	PartnerContextProps,
} from '../partner';
import { css } from '@emotion/css';

export interface PartnerProviderProps {
	children: React.ReactNode;
}

const PartnerContext = createContext<PartnerContextProps | null>(null);

export const PartnerProvider = ({
	children,
}: {
	children?: React.ReactNode;
}) => {
	const [partner, setPartner] = useState<PartnerContextProps>(condolivre);

	useEffect(() => {
		const { hostname = '' } = window.location;
		const isWohPag = hostname.startsWith('wohpag');
		const isPartnerbank = hostname.startsWith('partnerbank');
		if (isWohPag) {
			setPartner(wohpag);
		} else if (isPartnerbank) {
			setPartner(partnerbank);
		}
	}, []);

	return (
		<PartnerContext.Provider value={partner}>
			<div
				className={css`
					div:not(div:[data-type="restrain-style"] div) {
						background-color: ${partner.theme?.primary}!important;

						button:not([data-type='restrain-style']) {
							background-color: ${partner.theme?.primary}!important;

							&:hover {
								border-color: ${partner.theme?.secondary}!important;
								color: ${partner.theme?.secondary}!important;
							}
						}
					}

					div:not(form
							div, [data-type='restrain-style'], [data-type='restrain-style']
							div) {
						background-color: ${partner.theme?.primary}!important;
					}

					div[data-type='theme-style'] {
						background-color: ${partner.theme?.primary}!important;
					}
				`}>
				{children}
			</div>
		</PartnerContext.Provider>
	);
};

export const usePartner = () => {
	const context = useContext(PartnerContext as Context<PartnerContextProps>);
	if (context === undefined) {
		return condolivre;
	}
	return context || {};
};
